// English translations for Bucara Burger
const en = {
  // Navbar
  nav_home: 'Home',
  nav_about: 'About',
  nav_menu: 'Menu',
  nav_gallery: 'Gallery',
  nav_location: 'Location',
  nav_order_whatsapp: 'Order on WhatsApp',

  // Language switcher
  lang_en: 'EN',
  lang_es: 'ES',

  // Common buttons
  btn_order_whatsapp: 'Order on WhatsApp',
  btn_call_now: 'Call Now',
  btn_view_menu: 'View Menu',
  btn_view_full_menu: 'View Full Menu',
  btn_view_full_gallery: 'View Full Gallery',
  btn_follow_instagram: 'Follow on Instagram',
  btn_chat_whatsapp: 'Chat with Us on WhatsApp',
  btn_get_directions: 'Get Directions',
  btn_open_maps: 'Open in Google Maps',
  map_find_us: 'Find Us Here',
  map_open_maps_short: 'Open in Maps',
  map_directions_title: 'Use the map for directions',
  map_directions_sub: 'We\'re located at 1630 Broadway Ave, Boise, Idaho 83706. Tap "Open in Maps" to get turn-by-turn directions from your location.',
  btn_message_whatsapp: 'Message on WhatsApp',

  // Hero Section
  hero_badge: 'Colombian Food Truck · Boise, Idaho',
  hero_headline_1: 'FROM BUCARAMANGA-COLOMBIA',
  hero_headline_2: 'TO BOISE',
  hero_headline_3: 'WITH LOVE',
  hero_sub: 'Gourmet burgers, Bumanguesa-style perros calientes, Latin fast food, and refreshing tropical drinks — all made fresh to order with authentic Colombian passion.',
  hero_highlight_1: 'Made Fresh to Order',
  hero_highlight_2: 'Boise, Idaho',
  hero_highlight_3: 'Authentic Colombian Flavor',
  hero_highlight_4: 'Fast & Friendly Service',
  hero_highlight_5: 'WhatsApp Orders',

  // About Section (Home)
  about_eyebrow: 'Our Story',
  about_headline_1: 'Bringing the authentic flavor of',
  about_headline_2: 'Bucaramanga',
  about_headline_3: 'to Idaho',
  about_p1: 'Bucara Burger was born from a dream — two young Colombian entrepreneurs who left everything behind to bring the bold, authentic flavors of Colombia to the heart of Boise, Idaho. What started as a passion project fueled by late nights, family recipes, and an unshakeable belief in their food, quickly became something much bigger.',
  about_p2: "Inspired by the vibrant street food culture of Bucaramanga — Colombia's culinary capital — we crafted a menu that honors tradition while embracing the energy of modern Latin food. Every burger, every perro caliente, every arepa is made with the same love and dedication we brought from home.",
  about_p3: "Today, Bucara Burger is more than a food truck. It's a community, a culture, and a taste of Colombia right here in Idaho. We're proud to serve Boise, Meridian, Nampa, and beyond — one delicious bite at a time.",
  about_stat_1: '100% Colombian Recipes',
  about_stat_2: "Boise's Favorite Food Truck",
  about_feat_1_title: 'Made with Passion',
  about_feat_1_sub: 'Every single order',
  about_feat_2_title: 'Fresh Ingredients',
  about_feat_2_sub: 'No shortcuts, ever',
  about_feat_3_title: 'Proudly Local',
  about_feat_3_sub: 'Boise, Idaho',

  // Menu Section (Home)
  menu_eyebrow: 'What We Serve',
  menu_headline: 'Our',
  menu_headline_accent: 'Menu',
  menu_sub: 'Every item made fresh to order with authentic Colombian recipes and the finest ingredients.',

  // Gallery Section (Home)
  gallery_eyebrow: 'Fresh From the Truck',
  gallery_headline: 'Our',
  gallery_headline_accent: 'Gallery',
  gallery_sub: 'A visual feast — real food, real people, real Colombian passion.',

  // Location Section (Home)
  location_eyebrow: 'Find Us',
  location_headline: 'Location &',
  location_headline_accent: 'Contact',
  location_sub: 'Come find us in Boise, Idaho — or reach out on WhatsApp to place your order.',
  location_business_name: 'Bucara Burger',
  location_business_sub: 'Colombian Food Truck · Boise, Idaho',
  location_address_label: 'Address',
  location_phone_label: 'Phone',
  location_hours_label: 'Business Hours',
  location_follow_label: 'Follow Us',
  location_cta_title: "Hungry? We're Ready.",
  location_cta_sub: "Place your order on WhatsApp and we'll have it ready fresh for you.",
  location_cta_btn: 'Chat on WhatsApp Now →',
  location_today: 'Today',
  location_closed: 'Closed',
  day_monday: 'Monday',
  day_tuesday: 'Tuesday',
  day_wednesday: 'Wednesday',
  day_thursday: 'Thursday',
  day_friday: 'Friday',
  day_saturday: 'Saturday',
  day_sunday: 'Sunday',

  // Footer
  footer_tagline: 'Authentic Colombian flavors in the heart of Boise, Idaho. Made fresh, made with love.',
  footer_nav_title: 'Navigation',
  footer_social_title: 'Follow Us',
  footer_contact_title: 'Contact',
  footer_whatsapp_order: 'WhatsApp Order',
  footer_copyright: '© {year} Bucara Burger. All rights reserved. Colombian Food Truck · Boise, Idaho.',
  footer_serving: 'Serving Boise · Meridian · Nampa · Caldwell · Eagle · Kuna · Middleton · Star',
  footer_about: 'About Us',

  // About Page
  about_page_badge: 'Our Story · Boise, Idaho',
  about_page_title: 'About',
  about_page_title_accent: 'Bucara',
  about_page_title_2: 'Burger',
  about_page_sub: 'A Colombian food truck bringing authentic flavor, passion, and personality to Boise — one burger at a time.',
  about_story_label: 'Our Story',
  about_badge_colombian: 'Colombian',
  about_story_title: 'Born from a',
  about_story_title_accent: 'Colombian Dream',
  about_story_p1: 'Bucara Burger was born from the dream of two young Colombian entrepreneurs passionate about gastronomy and driven by the desire to share the authentic flavors of their homeland in the United States.',
  about_story_p2: 'What started as a small idea built with dedication and passion grew into a food truck concept with strong identity, quality, and character. Bucara Burger combines fresh ingredients, original recipes, and a unique urban style that connects with its roots.',
  about_story_p3: 'Today, the brand represents more than food — it represents effort, discipline, and the pride of bringing a piece of Colombia to every customer in Boise. As the go-to Colombian food truck in Boise, we serve authentic Colombian flavor in Idaho with every single order.',
  about_stat_label_1: 'Colombian Recipes',
  about_stat_label_2: 'Made to Order',
  about_stat_label_3: 'Idaho Based',
  about_stat_label_4: 'Made with Passion',
  about_why_eyebrow: 'What Sets Us Apart',
  about_why_title: 'Why',
  about_why_title_accent: 'Bucara Burger?',
  about_why_sub: "Four reasons why we're Boise's favorite Colombian food truck experience.",
  about_why_1_title: 'Authentic Colombian Flavor',
  about_why_1_desc: 'Every recipe is rooted in Colombian culinary tradition. We bring the real taste of Colombia to Latin food lovers in Boise — no shortcuts, no compromises.',
  about_why_2_title: 'Fresh Ingredients Made to Order',
  about_why_2_desc: 'We never pre-cook or reheat. Every burger, hot dog, and dish is prepared fresh the moment you order — because quality is non-negotiable.',
  about_why_3_title: 'Friendly and Fast Service',
  about_why_3_desc: 'We treat every customer like family. Fast, warm, and personal — the Bucara Burger experience is as good as the food itself.',
  about_why_4_title: 'Urban Food Truck with Latin Identity',
  about_why_4_desc: "We're not just a food truck — we're a cultural experience. Bold branding, Latin energy, and a vibe that makes every visit memorable.",
  about_exp_eyebrow: 'What We Offer',
  about_exp_title: 'Our',
  about_exp_title_accent: 'Experience',
  about_exp_sub: 'From gourmet burgers to Colombian drinks — everything we serve is made with passion and Colombian pride.',
  about_exp_1_title: 'Gourmet Burgers',
  about_exp_1_desc: 'Handcrafted with premium beef patties, artisan brioche buns, and bold Colombian-inspired toppings. Every burger is a masterpiece built for flavor lovers in Boise and beyond.',
  about_exp_1_tag: 'Signature',
  about_exp_2_title: 'Colombian-Style Perros Calientes',
  about_exp_2_desc: 'Our perros calientes are a Colombian street food classic — loaded with crispy potato chips, sauces, and toppings that turn a simple hot dog into an unforgettable experience.',
  about_exp_2_tag: 'Fan Favorite',
  about_exp_3_title: 'Latin Fast Food Favorites',
  about_exp_3_desc: 'From papas fritas to loaded snacks, our Latin fast food menu brings the energy of Colombian street corners straight to the streets of Boise, Idaho.',
  about_exp_3_tag: 'Street Style',
  about_exp_4_title: 'Refreshing Colombian Drinks',
  about_exp_4_desc: 'Cool down with tropical Colombian beverages — from fresh lemonadas to traditional drinks that pair perfectly with every bite on our menu.',
  about_exp_4_tag: 'Refreshing',
  about_exp_5_title: 'Walk-Up & Pickup Service',
  about_exp_5_desc: 'Find us at our regular spots around Boise. Walk up, order fresh, and enjoy your food on the spot. No wait, no fuss — just great Colombian food truck energy.',
  about_exp_5_tag: 'Food Truck',
  about_exp_6_title: 'Catering Available',
  about_exp_6_desc: 'Planning an event in Boise, Meridian, or Nampa? Bucara Burger is available for private events, corporate catering, and special occasions. Contact us on WhatsApp to book.',
  about_exp_6_tag: 'Events',
  about_cta_eyebrow: 'Come Find Us',
  about_cta_title: 'Ready to Try',
  about_cta_title_accent: 'Bucara Burger?',
  about_cta_sub: "Come experience authentic Colombian flavor in Boise. Order on WhatsApp, give us a call, or explore our full menu — we're ready to serve you something unforgettable.",

  // Menu Page
  menu_page_badge: 'Colombian Food Truck Boise',
  menu_page_title: 'Our',
  menu_page_title_accent: 'Menu',
  menu_page_intro: 'At Bucara Burger, every order is prepared fresh with bold flavor, quality ingredients, and a Colombian touch. From gourmet burgers to authentic perros calientes — there\'s something for everyone.',
  menu_page_seo: 'The best Colombian burgers in Boise Idaho · Latin food Boise · Comida colombiana en Boise',
  menu_note: 'Freshly made to order. Menu items may vary based on availability. Prices subject to change without notice. Contact us directly via WhatsApp or phone for current availability and special requests.',
  menu_note_bold: 'Freshly made to order.',
  menu_cta_eyebrow: 'Ready to eat?',
  menu_cta_title: 'Order Your Favorite',
  menu_cta_title_2: 'Colombian Flavor',
  menu_items_label: 'item',
  menu_items_label_plural: 'items',

  // Menu Category Labels
  cat_burgers: 'Burgers',
  cat_hotdogs: 'Colombian Hot Dogs',
  cat_latin_specials: 'Bucaramanga Specialties',
  cat_kids: 'Kids Menu',
  cat_empanadas: 'Empanadas and Stuffed Potatoes',
  cat_arepas: 'Stuffed Arepas',
  cat_juices: 'Natural Juices',
  cat_drinks: 'Drinks',

  // Size options
  size_label: 'Size',
  size_one_person: 'For one person',
  size_two_people: 'For two people',

  // Menu Item Names & Descriptions
  item_bucara_classic_name: 'Bucara Classic Burger',
  item_bucara_classic_desc: 'Juicy beef patty, cheddar cheese, caramelized onions, lettuce, tomato, and our secret Bucara sauce on a brioche bun.',
  item_doble_colombiana_name: 'Doble Colombiana',
  item_doble_colombiana_desc: 'Double smash patties, double cheese, crispy bacon, jalapeños, pineapple, and Colombian-style pink sauce. Bold and unforgettable.',
  item_pollo_paisa_name: 'Pollo Paisa Burger',
  item_pollo_paisa_desc: 'Crispy fried chicken breast, coleslaw, avocado, pickled red onions, and chipotle mayo on a toasted sesame bun.',
  item_bucara_bbq_name: 'Bucara BBQ Burger',
  item_bucara_bbq_desc: 'Smoky beef patty glazed with BBQ sauce, crispy onion rings, bacon, cheddar, and pickles on a toasted brioche bun.',
  item_mushroom_swiss_name: 'Mushroom Swiss Burger',
  item_mushroom_swiss_desc: 'Beef patty topped with sautéed mushrooms, Swiss cheese, garlic aioli, arugula, and caramelized onions on a pretzel bun.',
  item_nueva_burger_name: 'La Bumanguesa',
  item_nueva_burger_desc: 'Our bold Bucaramanga-style burger with chorizo crumbles, hogao sauce, crispy chicharrón bits, avocado, and white cheese on a toasted bun.',
  item_perro_clasico_name: 'Perro Caliente Colombiano Clásico',
  item_perro_clasico_desc: 'All-beef perro caliente loaded with crushed chips, pineapple sauce, pink sauce, mustard, ketchup, and queso costeño. The real deal.',
  item_perro_especial_name: 'Perro Caliente Especial Bucara',
  item_perro_especial_desc: 'Jumbo beef perro caliente, bacon strips, caramelized onions, jalapeño relish, all our signature sauces, and a mountain of toppings.',
  item_perro_tropical_name: 'Perro Caliente Tropical',
  item_perro_tropical_desc: 'Grilled perro caliente with mango salsa, coconut cream, toasted coconut flakes, and a hint of lime. A tropical Colombian twist.',
  item_perro_picante_name: 'Perro Caliente Picante',
  item_perro_picante_desc: 'Spicy perro caliente with jalapeños, habanero sauce, crispy shallots, sriracha mayo, and crushed tortilla chips for extra crunch.',
  item_desgranado_name: 'Desgranado',
  item_desgranado_desc: 'Colombian street corn off the cob, tossed with butter, cheese, mayo, lime, and a sprinkle of chili powder. A crowd favorite.',
  item_picada_name: 'Picada Colombiana',
  item_picada_desc: 'A generous sharing platter of grilled chorizo, chicharrón, papa criolla, morcilla, and arepas. Perfect for sharing.',
  item_patacon_name: 'Patacón Mixto',
  item_patacon_desc: 'Twice-fried green plantain base loaded with shredded beef, chicken, hogao, avocado, and crumbled white cheese.',
  item_kids_burger_name: 'Kids Burger Meal',
  item_kids_burger_desc: 'Mini beef burger with cheese, ketchup, and mild toppings. Served with small fries and a juice box. Kids love it!',
  item_kids_salchipapa_name: 'Kids Salchipapa Meal',
  item_kids_salchipapa_desc: 'Sliced beef sausage with crispy golden fries, ketchup, and mayo. A Colombian classic kids absolutely love.',
  item_empanada_mixta_name: 'Empanada de Trigo Mixta',
  item_empanada_mixta_desc: 'Crispy wheat empanada stuffed with a savory mix of seasoned beef and chicken, served with ají dipping sauce.',
  item_empanada_pollo_name: 'Empanada de Trigo Pollo Queso',
  item_empanada_pollo_desc: 'Golden wheat empanada filled with tender shredded chicken and melted cheese. Crispy outside, gooey inside.',
  item_empanada_yuca_name: 'Empanada de Yuca',
  item_empanada_yuca_desc: 'Traditional yuca (cassava) empanada with a crispy shell, filled with seasoned ground beef and spices. Gluten-free.',
  item_arepa_carne_name: 'Arepa Rellena de Carne',
  item_arepa_carne_desc: 'Thick grilled corn arepa stuffed with juicy seasoned shredded beef, hogao sauce, and melted cheese. A Colombian staple.',
  item_arepa_pollo_name: 'Arepa Rellena de Pollo',
  item_arepa_pollo_desc: 'Grilled corn arepa filled with tender shredded chicken, creamy avocado, hogao, and fresh white cheese.',
  item_arepa_nueva1_name: 'Arepa Rellena de Chicharrón',
  item_arepa_nueva1_desc: 'Thick grilled corn arepa loaded with crispy chicharrón, hogao tomato sauce, avocado, and a drizzle of ají. A true Bumanguesa classic.',
  item_arepa_nueva2_name: 'Arepa Rellena Mixta',
  item_arepa_nueva2_desc: 'The best of everything — shredded beef, chicken, chicharrón, hogao sauce, melted cheese, and avocado all stuffed inside a thick grilled arepa.',
  item_jugo_limonada_name: 'Natural Lemonade',
  item_jugo_limonada_desc: 'Fresh-squeezed Colombian lemonade with a perfect balance of sweet and tart. Made to order with real lemons.',
  item_jugo_guanabana_name: 'Natural Soursop Juice',
  item_jugo_guanabana_desc: 'Creamy and exotic soursop juice, naturally sweet with a tropical flavor unique to Colombian cuisine.',
  item_jugo_maracuya_name: 'Natural Passion Fruit Juice',
  item_jugo_maracuya_desc: 'Vibrant passion fruit juice bursting with tropical flavor. Tangy, refreshing, and 100% natural.',
  item_jugo_mora_name: 'Natural Blackberry Juice',
  item_jugo_mora_desc: 'Rich blackberry juice made from fresh Colombian mora berries. Deep, fruity, and naturally sweet.',
  item_jugo_salpicon_name: 'Salpicón Fruit Drink',
  item_jugo_salpicon_desc: 'A refreshing Colombian fruit cocktail with mixed tropical fruits, watermelon juice, and a splash of soda. Colorful and delicious.',
  item_soda_water_name: 'Soda & Bottled Water',
  item_soda_water_desc: 'Assorted sodas (Coke, Sprite, Fanta, Diet Coke) and still or sparkling bottled water to complete your meal.',

  // Gallery Categories
  gallery_cat_burgers: 'Signature Burgers',
  gallery_cat_burgers_sub: 'Gourmet Colombian burgers crafted with bold flavors and premium ingredients',
  gallery_cat_hotdogs: 'Colombian Hot Dogs',
  gallery_cat_hotdogs_sub: 'Authentic perros colombianos loaded with bold toppings and signature sauces',
  gallery_cat_fastfood: 'Latin Fast Food',
  gallery_cat_fastfood_sub: 'Empanadas, arepas, patacones, and Colombian street food favorites',
  gallery_cat_truck: 'Food Truck Experience',
  gallery_cat_truck_sub: 'The energy, the vibe, and the culture behind Bucara Burger in Boise',
  gallery_cat_atmosphere: 'Brand Moments & Atmosphere',
  gallery_cat_atmosphere_sub: 'The soul, identity, and Colombian spirit that makes Bucara Burger unique',

  // Gallery Page
  gallery_page_badge: 'Food Truck in Boise · Colombian Food in Idaho',
  gallery_page_title: 'Our',
  gallery_page_title_accent: 'Gallery',
  gallery_page_sub: 'A look at the flavor, style, and experience of Bucara Burger',
  gallery_page_intro: 'Every dish at Bucara Burger is made to stand out — from presentation to flavor. Our gallery reflects the energy, freshness, and Colombian identity behind every order.',
  gallery_cta_eyebrow: 'Burgers & Latin Food in Boise',
  gallery_cta_title: 'See something',
  gallery_cta_title_accent: "you're craving?",
  gallery_section_1: 'Signature Burgers',
  gallery_section_2: 'Colombian Perros Calientes',
  gallery_section_3: 'Latin Fast Food',
  gallery_section_4: 'Food Truck Experience',
  gallery_section_5: 'Brand Moments / Atmosphere',

  // Location Page
  location_page_badge: 'Colombian Food Truck · Boise, Idaho',
  location_page_title: 'Location &',
  location_page_title_accent: 'Contact',
  location_page_sub: "Visit Bucara Burger in Boise or get in touch directly — we're always ready to serve you authentic Colombian flavor.",
  location_address_title: 'Address',
  location_phone_title: 'Phone',
  location_phone_tap: 'Tap to call directly',
  location_wa_title: 'Message on WhatsApp',
  location_wa_sub: 'Fastest way to reach us · We reply quickly',
  location_hours_title: 'Business Hours',
  location_social_title: 'Follow Us',
  location_map_title: 'Find Us on the Map',
  location_map_note: 'Use the map for directions',
  location_quick_title: 'Reach Us Instantly',
  location_quick_eyebrow: 'Quick Actions',
  location_call_sub: 'Speak with us directly',
  location_wa_action_sub: 'Fastest way to order',
  location_menu_sub: 'See all items',
  location_area_badge: 'Treasure Valley, Idaho',
  location_area_title: 'Serving Boise & Nearby Areas',
  location_area_text: 'Bucara Burger proudly serves <strong>Boise</strong> and nearby Idaho communities looking for authentic Colombian flavor, gourmet burgers, perros calientes, and Latin food truck favorites. Whether you\'re in <strong>Meridian</strong>, <strong>Nampa</strong>, <strong>Caldwell</strong>, or anywhere in the Treasure Valley — we\'re your go-to Colombian street food in Idaho.',
  location_trust_1_title: 'Food Truck in Boise Idaho',
  location_trust_1_desc: 'Find us parked at 1630 Broadway Ave, Boise. The best Colombian street food in the Treasure Valley.',
  location_trust_2_title: 'Colombian Street Food Idaho',
  location_trust_2_desc: 'Authentic burgers, perros calientes, empanadas, arepas, and natural juices — made fresh with Colombian recipes.',
  location_trust_3_title: 'Latin Food Near Boise',
  location_trust_3_desc: 'Serving the Boise metro area with bold Latin flavors. Order on WhatsApp or call us directly.',

  // Admin Nav
  admin_nav_dashboard: 'Dashboard',
  admin_nav_activity: 'Activity',
  admin_nav_users: 'Users',
  admin_nav_categories: 'Categories',
  admin_nav_menu: 'Menu',
  admin_nav_gallery_categories: 'Gallery Categories',
  admin_nav_gallery: 'Gallery',
  admin_nav_landing_images: 'Landing Images',
  admin_nav_business: 'Business Info',
  admin_nav_logout: 'Logout',
};

export default en;
